var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLieu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10C12 11.0609 12.4214 12.0783 13.1716 12.8284C13.9217 13.5786 14.9391 14 16 14C17.0609 14 18.0783 13.5786 18.8284 12.8284C19.5786 12.0783 20 11.0609 20 10C20 8.93913 19.5786 7.92172 18.8284 7.17157C18.0783 6.42143 17.0609 6 16 6C14.9391 6 13.9217 6.42143 13.1716 7.17157C12.4214 7.92172 12 8.93913 12 10V10Z",
    stroke: "#7E8EAA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 1C18.3869 1 20.6761 1.94821 22.364 3.63604C24.0518 5.32387 25 7.61305 25 10C25 14.3347 18.1573 24.036 16.4053 26.4493C16.3586 26.513 16.2976 26.5648 16.2272 26.6004C16.1568 26.6361 16.0789 26.6547 16 26.6547C15.9211 26.6547 15.8432 26.6361 15.7728 26.6004C15.7024 26.5648 15.6414 26.513 15.5947 26.4493C13.8427 24.036 7 14.3347 7 10C7 7.61305 7.94821 5.32387 9.63604 3.63604C11.3239 1.94821 13.6131 1 16 1V1Z",
    stroke: "#7E8EAA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.972 23.7119C27.6147 24.4332 30 25.6372 30 26.9999C30 29.2092 23.7333 30.9999 16 30.9999C8.26667 30.9999 2 29.2092 2 26.9999C2 25.6399 4.37467 24.4386 8 23.7159",
    stroke: "#7E8EAA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLieu);
export default __webpack_public_path__ + "static/media/lieu.b0d5fec714c8dad48b8745e63ad2e6c7.svg";
export { ForwardRef as ReactComponent };